import { BRAND } from "../../constants";
import { CAROUSEL_HEIGHTS, CarouselHeightsSizes } from "../../models/types/Carousel.type";
import { ChevronLeft, ChevronRight } from "../Images";

type CarouselControlsProps = {
  showButtons: { showLeft: boolean; showRight: boolean }
  handleNavigate: (direction: string) => void
  size: CarouselHeightsSizes
  isLarge: boolean
}

const CarouselControls = ({ showButtons, handleNavigate, size, isLarge }: CarouselControlsProps) => {
  const { showLeft, showRight } = showButtons

  return (
    <div>
      <button
        aria-label='Previous'
        className={`carousel-button left ${showLeft ? '' : 'hidden'}`}
        onClick={() => handleNavigate('left')}>
        <ChevronLeft />
      </button>
      <button
        aria-label='Next'
        className={`carousel-button right ${showRight ? '' : 'hidden'}`}
        onClick={() => handleNavigate('right')}>
        <ChevronRight />
      </button>
      <style jsx>{`
        .carousel-button {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          z-index: 500;
          top: ${CAROUSEL_HEIGHTS[size].controlHeight}px;
          width: 32px;
          height: 32px;
          background: #ffffff;
          // border: 1px solid #bfbfbf;
          box-shadow: 1px 1px 5px black;
          border-radius: 2px;
          font-size: 18px;
          transition: all 0.2s ease-in-out;
          -moz-transition: all 0.2s ease-in-out;
          -webkit-transition: all 0.2s ease-in-out;
          color: #4a4c49;
        }

        .left {
          left: ${isLarge ? 'calc(5% - 18px)' : 0};
        }

        .right {
          right: ${isLarge ? 'calc(5% - 18px)' : 0};
        }

        .hidden {
          visibility: hidden;
          display: none;
        }

        .carousel-button:hover {
          cursor: pointer;
          background-color: #BFBFBF;
          // border-color: ${BRAND.primaryColour};
          color: white;
          transition: all 0.2s ease-in-out;
          -moz-transition: all 0.2s ease-in-out;
          -webkit-transition: all 0.2s ease-in-out;
        }

        @media screen and (max-width: ${BRAND.media.small}px) {
          .carousel-button {
            top: ${isLarge ? CAROUSEL_HEIGHTS.medium.controlHeight : CAROUSEL_HEIGHTS[size].controlHeight}px;
          }

          .left {
            left: 0;
          }

          .right {
            right: 0;
          }
        }
      `}</style>
    </div>
  )
}

export default CarouselControls